/** @jsx h */
import { h } from 'preact'

const Chevron = () => (
  <svg xmlnsXlink='http://www.w3.org/1999/xlink' width={48} height={48}>
    <defs>
      <filter
        id='a'
        width='119.6%'
        height='113%'
        x='-9.8%'
        y='-3.3%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy={16} in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation={8}
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'
        />
      </filter>
      <linearGradient id='c' x1='50%' x2='50%' y1='0%' y2='100%'>
        <stop offset='0%' stopColor='#FFF' stopOpacity={0} />
        <stop offset='100%' stopColor='#FFF' />
      </linearGradient>
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(-140 -420)'>
      <use fill='#000' filter='url(#a)' xlinkHref='#b' />
      <g transform='translate(140 420)'>
        <g
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
        >
          <path d='M24 20l8 8M24 20l-8 8' />
        </g>
      </g>
    </g>
  </svg>
)

export default Chevron
